import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import I18n from 'i18n-react';
import Moment from 'moment';
import FlightList from '../flightList/FlightList';
import PassengerList from '../passengerList/PassengerList';

import './FlightResume.css';

const propTypes = {
  isCallcenterEnabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  departureFlight: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    departureDate: PropTypes.string,
    departureTime: PropTypes.arrayOf(PropTypes.number),
    flightGroup: PropTypes.arrayOf(
      PropTypes.shape({
        flightNumber: PropTypes.number,
        operatingCarrier: PropTypes.string,
        marketingCarrier: PropTypes.string,
        origin: PropTypes.string.required,
        destination: PropTypes.string.required,
        isThroughFlight: PropTypes.bool,
        departureDate: PropTypes.string,
        departureTime: PropTypes.arrayOf(PropTypes.number),
        arrivalDate: PropTypes.string,
        arrivalTime: PropTypes.arrayOf(PropTypes.number)
      })
    ),
    baggage: PropTypes.shape({
      category: PropTypes.string.isRequired,
      quantity: PropTypes.number,
      weight: PropTypes.number
    })
  }).isRequired,
  returnFlight: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    departureDate: PropTypes.string,
    departureTime: PropTypes.arrayOf(PropTypes.number),
    flightGroup: PropTypes.arrayOf(
      PropTypes.shape({
        flightNumber: PropTypes.number,
        operatingCarrier: PropTypes.string,
        marketingCarrier: PropTypes.string,
        origin: PropTypes.string.required,
        destination: PropTypes.string.required,
        isThroughFlight: PropTypes.bool,
        departureDate: PropTypes.string,
        departureTime: PropTypes.arrayOf(PropTypes.number),
        arrivalDate: PropTypes.string,
        arrivalTime: PropTypes.arrayOf(PropTypes.number)
      })
    ),
    baggage: PropTypes.shape({
      category: PropTypes.string.isRequired,
      quantity: PropTypes.number,
      weight: PropTypes.number
    })
  }),
  passengers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastName: PropTypes.string,
      tudoAzulNumber: PropTypes.string,
      ticketNumber: PropTypes.string
    })
  ).isRequired
};

class FlightResume extends React.Component {
  renderFlight(flight, isReturnFlight) {
    return (
      <div className="FlightResume__flights">
        <Row>
          <Col sm={9} xsHidden>
            <label
              className={`FlightResume__departureDate ${
                isReturnFlight ? 'returnFlightDate-desktop' : 'departureFlightDate-desktop'
              }`}>
              {Moment(flight.departureDate, 'DD/MM/YYYY').format('dddd, D [de] MMMM [de] YYYY')}
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={12} xsHidden>
            <label className="FlightResume__flightType">
              {isReturnFlight
                ? I18n.translate('components.resume.returnFlight')
                : I18n.translate('components.resume.departureFlight')}
            </label>
            <label
              className={`FlightResume__airport ${
                isReturnFlight ? 'returnOriginName-desktop' : 'departureOriginName-desktop'
              }`}>
              {flight.originAirportName}
            </label>
            <label className="FlightResume__airport FlightResume__to">
              {I18n.translate('components.resume.to')}
            </label>
            <label
              className={`FlightResume__airport ${
                isReturnFlight
                  ? 'returnDestinationName-desktop'
                  : 'departureDestinationName-desktop'
              }`}>
              {flight.finalDestinationName}
            </label>
          </Col>
          <Col xs={12} smHidden mdHidden lgHidden>
            <label className="FlightResume__flightType">
              {isReturnFlight
                ? I18n.translate('components.resume.returnFlight')
                : I18n.translate('components.resume.departureFlight')}
            </label>
            <label
              className={`FlightResume__departureDate ${
                isReturnFlight ? 'returnFlightDate-mobile' : 'departureFlightDate-mobile'
              }`}>
              {Moment(flight.departureDate, 'DD/MM/YYYY').format('ddd, D [de] MMM [de] YYYY')}
            </label>
          </Col>
        </Row>
        <Row>
          <Col xs={12} smHidden mdHidden lgHidden>
            <label
              className={`FlightResume__airport ${
                isReturnFlight ? 'returnOriginName-mobile' : 'departureOriginName-mobile'
              }`}>
              {flight.originAirportName}
            </label>
            <label className="FlightResume__airport FlightResume__to">
              {I18n.translate('components.resume.to')}
            </label>
            <label
              className={`FlightResume__airport ${
                isReturnFlight ? 'returnDestinationName-mobile' : 'departureDestinationName-mobile'
              }`}>
              {flight.finalDestinationName}
            </label>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} className="FlightResume__flightList">
            <FlightList
              id={`flightResume-${isReturnFlight ? 'return' : 'departure'}`}
              flights={flight.flightGroup}
              category={flight.category}
              baggage={flight.baggage}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} smHidden mdHidden lgHidden className="FlightResume__checkin">
            <label className="FlightResume__checkinLabel">
              <i className="FlightResume__checkinIcon" />
              {I18n.translate('components.resume.checkin')}
            </label>
          </Col>
        </Row>
        {this.renderPassengers(isReturnFlight)}
        <Row>
          <Col sm={12} xsHidden className="FlightResume__baggage">
            <div className="FlightResume__tableCell">
              <i className="FlightResume__baggageIcon" />
              <label className="FlightResume__baggageRules">
                {I18n.translate('components.resume.baggageRules')}
              </label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} smHidden mdHidden lgHidden className="FlightResume__baggage">
            <label className="FlightResume__baggageRules">
              <i className="FlightResume__baggageIcon" />
              {I18n.translate('components.resume.baggageRules')}
            </label>
          </Col>
        </Row>
      </div>
    );
  }

  renderPassengers(isReturnFlight) {
    return (
      <Row className="FlightResume__passengersContainer">
        <Col xs={12} className="FlightResume__passengers">
          <PassengerList
            id={`flightPassengers-${isReturnFlight ? 'return' : 'departure'}`}
            passengers={this.props.passengers}
            isCallcenterEnabled={this.props.isCallcenterEnabled}
          />
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div id={this.props.id}>
        {this.renderFlight(this.props.departureFlight, false)}
        {this.props.returnFlight ? this.renderFlight(this.props.returnFlight, true) : ''}
      </div>
    );
  }
}

FlightResume.propTypes = propTypes;

export default FlightResume;



// WEBPACK FOOTER //
// ./src/components/bookingResume/flightResume/FlightResume.jsx